import { InjectionToken } from '@angular/core';

// Fonction de check du drag over sur un élément HTML
export type WizDropControlFn = (pEvent: WizDropItemEvent) => boolean;

// InjectionToken à provider dans les composants gérant du drag/drop
export const WIZ_DRAGGABLE_COMPONENT: InjectionToken<WizDraggableComponent> =
  new InjectionToken('WIZ_DRAGGABLE_COMPONENT');

/**
 * Interface de composant gérant du drag/drop.
 * Deux contraintes :
 *  - contenir un container dans son DOM avec la directive [wizDragDrop].
 *  - Provider l'injectionToken WIZ_DRAGGABLE_COMPONENT
 */
export interface WizDraggableComponent {
  /** Fonction de contrôle sur dragOver param = item return true si drop autorisé */
  checkDragOver(pEvent: WizDropItemEvent): boolean;

  /** Ajout d'un élément suite à un drop sur ce composant */
  onAddItemAfterDrag(pEvent: WizDropItemEvent): void;

  /** Déplacement d'un élément après drop (car drag/drop en interne) */
  onMoveItemAfterDrag(pEvent: WizDropItemEvent): void;

  /** Suppression d'un élément car drop dans un autre container */
  onRemoveItemAfterDrag(pItem: WizDraggableItem): void;
}

/**
 * Item drag/droppé
 */
export interface WizDraggableItem {
  // Element html à déplacer
  readonly target: any;

  // Objet métier lié à l'élement (optionnel)
  readonly data?: any;
}

/**
 * Event de drop d'élément sur un container.
 *
 * @param event DragEvent source
 * @param item élément qui va être droppé.
 * @param targetPosition position de drop dans le container parent
 */
export interface WizDropItemEvent {
  event: DragEvent;
  item: WizDraggableItem;
  targetPosition: number;
  dragSource: WizDraggableComponent
}
